const awsRumCustomActions = {
    SESSION_OPENED: 'SessionOpened',
    SESSION_COMPLETED: 'SessionCompleted',
    FEEDBACK_SHOWN: 'FeedbackShown',
    FEEDBACK_SUBMITTED: 'FeedbackSubmitted',
    FEEDBACK_SUBMIT_ERROR: 'FeedbackSubmitError',
    FEEDBACK_DISMISSED: 'FeedbackDismissed',
    HIGH_TEMPERATURE_MODAL_SHOWN: 'HighTemperatureModalShown',
    HIGH_TEMPERATURE_MODAL_CLOSED: 'HighTemperatureModalClosed',
    HIGH_TEMPERATURE_MODAL_GOT_IT_CLICKED: 'HighTemperatureModalGotItClicked',
};

export default awsRumCustomActions;
